import { Link } from "react-router-dom";
import classes from "./Dropdown.module.css";

interface DropdownItem {
  link: string;
  label: string;
}

interface DropdownProps {
  scrolled: boolean;
  offHover: () => void;
  items: DropdownItem[];
}

const Dropdown: React.FC<DropdownProps> = ({ scrolled, offHover, items }) => {
  const topPos = scrolled ? "50px" : "60px";
  const backgroundColor = scrolled ? "#2e2e2e" : "rgba(0, 0, 0, 0.6)";

  return (
    <div
      className={classes.div}
      style={{ top: topPos }}
      onMouseLeave={offHover}
    >
      {items.map((item, index) => (
        <Link
          style={{ backgroundColor }}
          key={index}
          to={item.link}
          className={classes.Link}
          onClick={offHover}
        >
          {item.label}
        </Link>
      ))}
    </div>
  );
};

export default Dropdown;
